import { useState, useEffect, useCallback } from "react";
import { getUsers } from "../services/userService";

/**
 * Custom hook for fetching team members
 * @param {number} limit - Maximum number of users to fetch
 * @param {number} offset - Offset for pagination
 * @returns {Object} { teamMembers, loading, error, refresh }
 */
export const useTeamMembers = (limit = 50, offset = 0) => {
  const [teamMembers, setTeamMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchTeamMembers = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await getUsers({ limit, offset });

      if (response.success && response.data) {
        setTeamMembers(response.data);
      } else {
        setError(response.message || "Failed to load team members");
      }
    } catch (err) {
      console.error("Error loading team members:", err);
      setError("An error occurred while loading team members");
    } finally {
      setLoading(false);
    }
  }, [limit, offset]);

  useEffect(() => {
    fetchTeamMembers();
  }, [fetchTeamMembers]);

  return { teamMembers, loading, error, refresh: fetchTeamMembers };
};
